module.exports = __webpack_public_path__ + "assets/img/202111-2W.27693611.png";